"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.array.sort");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
var _aggregatePageManagement = require("@/api/operationManagement/aggregatePageManagement");
var _ossUpload = require("@/utils/ossUpload");
var _ActivitySelectionPopup = _interopRequireDefault(require("./ActivitySelectionPopup.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    ActivitySelectionPopup: _ActivitySelectionPopup.default
  },
  data: function data() {
    return {
      dialogVisible: false,
      conditionType: {},
      // 条件
      ruleForm: {
        id: null,
        name: '',
        // 活动名称
        colorValue: '',
        // 背景色值
        pic: '',
        // 第一张图片
        activityList: [{
          activityId: null,
          activityPic: '',
          unionCode: null,
          sort: null,
          activityName: '',
          startTime: '',
          // 活动开始时间
          endTime: '' // 活动结束时间
        }]
      },
      rules: {
        name: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }, {
          min: 0,
          max: 99,
          message: '长度在 0 到 99 个字符',
          trigger: 'blur'
        }],
        colorValue: [{
          required: true,
          message: '请输入背景色值',
          trigger: 'blur'
        }, {
          min: 0,
          max: 99,
          message: '长度在 0 到 99 个字符',
          trigger: 'blur'
        }]
      },
      addEditor: '',
      // 新增编辑
      returnMark: null,
      // 类型映射
      PlatformTypeList: {
        WPH: '唯品会',
        TB: '淘宝',
        JD: '京东',
        PDD: '拼多多',
        DY: '抖音',
        ELM: '饿了么',
        MT: '美团',
        KS: '快手'
      }
    };
  },
  methods: {
    open: function open(data) {
      this.conditionType = data;
      console.log(data);

      /*
      接收data对象：
      type：add、editor（添加，编辑）
      name：名称
      id：id
      */
      this.dialogVisible = true;
      this.addEditor = data.type;
      if (data.type === 'editor') {
        // this.activeEcho(data)
        this.aggregatePageDetail(data.id);
      }
    },
    // 活动回显
    // activeEcho(data) {
    //   this.ruleForm.name = data.item.name
    //   this.ruleForm.colorValue = data.item.colorValue
    //   this.ruleForm.id = data.item.id
    //   this.ruleForm.activityList = data.item.activityList
    // },
    // 关闭
    onClose: function onClose() {
      this.resetForm('ruleForm');
      this.onInitialize();
      this.dialogVisible = false;
    },
    // 新增item
    onNewActivity: function onNewActivity() {
      this.ruleForm.activityList.push({
        activityId: null,
        activityPic: '',
        unionCode: null,
        sort: null
      });
    },
    // 删除item
    onDelNewActivity: function onDelNewActivity(index) {
      var _this = this;
      this.$confirm('是否确删除此项?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.ruleForm.activityList.splice(index, 1);
      });
    },
    // 选择活动
    onOfficialEvent: function onOfficialEvent(index) {
      this.returnMark = index;
      this.$refs.activitySelectionPopup.open();
    },
    // 自定义活动功能回传
    onSelectEvents: function onSelectEvents(data) {
      console.log('data', data);
      this.ruleForm.activityList[this.returnMark].activityId = data.id;
      this.ruleForm.activityList[this.returnMark].activityPic = data.mainImage;
      this.ruleForm.activityList[this.returnMark].unionCode = data.unionCode;
      this.ruleForm.activityList[this.returnMark].activityName = data.name;
      // startTime: '', // 活动开始时间
      // endTime: '' // 活动结束时间
      this.ruleForm.activityList[this.returnMark].startTime = data.startTime;
      this.ruleForm.activityList[this.returnMark].endTime = data.endTime;
      console.log('this.ruleForm.activityList[this.returnMark]', this.ruleForm.activityList[this.returnMark]);
    },
    // 自定义校验整个activityList的方法
    validateActivityList: function validateActivityList() {
      var errors = [];
      this.ruleForm.activityList.forEach(function (item, index) {
        if (item.sort == null) {
          errors.push("\u6D3B\u52A8".concat(index + 1, "\u7684\u6392\u5E8F\u503C\u4E0D\u80FD\u4E3A\u7A7A"));
        }
      });
      if (errors.length > 0) {
        // 处理错误，比如显示错误信息
        this.$message.error(errors.join());
        return false; // 表示校验失败
      }
      return true; // 表示校验成功
    },
    submitForm: function submitForm(formName) {
      var _this2 = this;
      if (this.ruleForm.activityList.length === 0 || !this.ruleForm.activityList[0].activityId) {
        this.$message.error('最少选择一项活动进行聚合');
        return false;
      }
      if (this.validateActivityList()) {
        // 校验通过，执行提交操作
        console.log('表单提交');
        this.$refs[formName].validate(function (valid) {
          if (valid) {
            if (_this2.addEditor === 'editor') {
              _this2.$confirm('是否确修改聚合页?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(function () {
                _this2.aggregatePageUpdate();
              });
            } else {
              _this2.$confirm('是否确保存聚合页?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(function () {
                _this2.aggregatePageSave();
              });
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      } else {
        return;
      }
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm.name = '';
      this.ruleForm.colorValue = '';
      this.ruleForm.pic = '';
      this.ruleForm.activityList = [{
        activityId: null,
        activityPic: '',
        unionCode: null,
        sort: null
      }];
    },
    // 图片上传
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      // this.ruleForm.mainImage = URL.createObjectURL(file.raw)
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              console.log('pictureUrl---------', pictureUrl);
              this.ruleForm.mainImage = pictureUrl;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    // 初始化
    onInitialize: function onInitialize() {
      this.ruleForm = {
        id: null,
        name: '',
        // 活动名称
        colorValue: '',
        // 背景色值
        activityList: [{
          activityId: null,
          activityPic: '',
          unionCode: null,
          sort: null,
          activityName: '',
          startTime: '',
          endTime: ''
        }]
      };
      this.returnMark = null;
    },
    // 活动保存
    aggregatePageSave: function () {
      var _aggregatePageSave2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              params.pic = params.activityList[0].activityPic;
              _context2.n = 1;
              return (0, _aggregatePageManagement.aggregatePageSave)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.onClose();
                this.$emit('refresh');
                this.$notify.success({
                  title: '温馨提示',
                  message: '新增成功'
                });
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function aggregatePageSave() {
        return _aggregatePageSave2.apply(this, arguments);
      }
      return aggregatePageSave;
    }(),
    // 编辑
    aggregatePageUpdate: function () {
      var _aggregatePageUpdate2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              params.pic = params.activityList[0].activityPic;
              _context3.n = 1;
              return (0, _aggregatePageManagement.aggregatePageUpdate)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.$emit('refresh');
                this.onClose();
                this.$notify.success({
                  title: '温馨提示',
                  message: '编辑成功'
                });
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function aggregatePageUpdate() {
        return _aggregatePageUpdate2.apply(this, arguments);
      }
      return aggregatePageUpdate;
    }(),
    // 详情
    aggregatePageDetail: function () {
      var _aggregatePageDetail2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(id) {
        var params, res, data, _t4;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              params = {
                activityId: id
              };
              _context4.n = 1;
              return (0, _aggregatePageManagement.aggregatePageDetail)(params);
            case 1:
              res = _context4.v;
              if (res.code === 0) {
                console.log('res', res.data);
                console.log('res', res.data.name);
                data = res.data;
                this.ruleForm.name = data.name;
                this.ruleForm.colorValue = data.colorValue;
                this.ruleForm.id = data.id;
                this.ruleForm.activityList = data.activityDetailList;
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              console.log(_t4);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function aggregatePageDetail(_x2) {
        return _aggregatePageDetail2.apply(this, arguments);
      }
      return aggregatePageDetail;
    }()
  }
};